import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
  postData: {},
};

const postCorporateFinancialSlice = createSlice({
  name: "postCorporateFinancial",
  initialState,
  reducers: {
    postCorporateFinancialStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postCorporateFinancialSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.postMessage = action.payload.postMessage;
    },
    postCorporateFinancialDataSuccess(state, action) {
      state.postData = action.payload;
    },
    postCorporateFinancialFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postCorporateFinancialStart,
  postCorporateFinancialSuccess,
  postCorporateFinancialDataSuccess,
  postCorporateFinancialFailure,
  clearError,
  clearMessage,
} = postCorporateFinancialSlice.actions;

export default postCorporateFinancialSlice.reducer;
